import React, {useEffect, useState} from 'react';
import {
    ActionButtonWrapper,
    ActionContentLink,
    ActionContentWrapper,
    ActionWrapper,
    CreditBannerWrapper,
    CreditBannerContent,
    CreditBalanceLabel,
    CreditBalanceAmount,
    CreditBannerBackground,
    StyledCreditButton,
} from "./styles";
import FareRule from "../FareRule";
import {StyledTitle} from "../CustomAntdComponents/Typography";
import {Link} from "react-router-dom";
import {Button, Checkbox, Card, notification} from "antd";
import {useFlightSearchStore} from "../../store/flightSearch/flightSearchStore";
import {useAuthStore} from "../../store/auth/authStore";
import useIsMobile from "../../hooks/useIsMobile";
import {SpaceBetweenAlignContent} from "../CustomAntdComponents/Utitlities";
import FlightFareBreakdown from "./FlightFareBreakdown";
import ConditionsRule from '../TermsAndConditions';
import { DeleteOutlined } from "@ant-design/icons";
import { formatNumberAsCurrency } from "../../utils/helpers";
import { getAPI } from "../../utils/api";
import { APPLY_CREDIT } from "../../utils/constants";
import CreditBalIcon from "../../assets/images/credit-bal-icon.svg";

type Props = {
    proceedToPayment?: () => void;
    promoCodeEntered?: boolean;
}
const FlightPaymentBreakdown = ({ proceedToPayment, promoCodeEntered } : Props) => {
    const { isMobile } = useIsMobile();
    const {
        formData: {
            fareRuleAccepted
        },
        updateFormData
    } = useFlightSearchStore();
    const [accept, setAccept] = useState(Boolean(fareRuleAccepted));

    const handleChange = (e) => {
        setAccept(e.target.checked);
        updateFormData({
            fareRuleAccepted: e.target.checked
        });
    }

    useEffect(() => {
        setAccept(fareRuleAccepted);
    }, [fareRuleAccepted]);

     
    const { 
        isLoggedIn, 
        b2CUser, 
        creditApplied, 
        creditLoading, 
        setCreditLoading, 
        setCreditAppliedDetails, 
        clearCreditDetails, 
        removeCredit 
    } = useAuthStore();

    const handleApplyCredit = async () => {
        setCreditLoading(true);
        try {
            const response = await getAPI(APPLY_CREDIT);
            setCreditLoading(false);

            if (response.status === 200 && response.data?.IsSuccess) {
                const responseType = response.data.ResponseType;
                
                if (responseType.HasUsedDiscount) {
                    clearCreditDetails();
                    notification.error({
                        message: 'Credit discount has already been used.',
                        placement: 'bottom',
                    });
                } else {
                    setCreditAppliedDetails(responseType);
                    notification.success({
                        message: 'Credit applied successfully',
                        placement: 'bottom',
                    });
                }
            } else {
                const errorMsg = response.data?.ErrorMessageList?.[0] || 'Failed to apply credit.';
                clearCreditDetails();
                notification.error({
                    message: errorMsg,
                    placement: 'bottom',
                });
            }
        } catch (error) {
            setCreditLoading(false);
            clearCreditDetails();
            notification.error({
                message: 'An error occurred while applying credit.',
                placement: 'bottom',
            });
        }
    };

    const handleRemoveCredit = () => {
        removeCredit();
        notification.success({
            message: 'Credit removed successfully',
            placement: 'bottom',
        });
    };

    const renderCreditBanner = () => {
        if (!isLoggedIn || !b2CUser?.WalletBalance || b2CUser.WalletBalance <= 0) return null;

        return (
            <CreditBannerWrapper>
                <CreditBannerContent>
                    <CreditBalanceLabel>Credit balance</CreditBalanceLabel>
                    <CreditBalanceAmount>
                          {formatNumberAsCurrency(b2CUser?.WalletBalance || 0, "")}
                    </CreditBalanceAmount>
                </CreditBannerContent>

                <CreditBannerBackground>
                    <img src={CreditBalIcon} alt="" />
                </CreditBannerBackground>

                <CreditBannerContent>
                    {creditApplied ? (
                        <StyledCreditButton 
                            onClick={handleRemoveCredit} 
                            icon={<DeleteOutlined style={{ color: '#6B7280' }} />}
                        >
                            <span>Remove credit</span>
                        </StyledCreditButton>
                    ) : (
                        <StyledCreditButton 
                            onClick={handleApplyCredit} 
                            disabled={promoCodeEntered || creditLoading}
                            loading={creditLoading}
                        >
                            <span>Apply credit</span>
                        </StyledCreditButton>
                    )}
                </CreditBannerContent>
            </CreditBannerWrapper>
        );
    };

    return isMobile ? (
        <ActionWrapper>
            <ActionContentWrapper>
                <ActionButtonWrapper>
                    <Link to="/payment">
                        <Button block size="large" type="primary">
                            Continue to payment
                        </Button>
                    </Link>
                </ActionButtonWrapper>
            </ActionContentWrapper>
        </ActionWrapper>
    ) : (
        <Card bodyStyle={{ padding: '24px' }} bordered={false} style={{ borderRadius: '20px',   }}>
            {renderCreditBanner()}
            <SpaceBetweenAlignContent style={{ marginBottom: '16px' }}>
                <StyledTitle level={4}>
                    Price breakdown
                </StyledTitle>
            </SpaceBetweenAlignContent>

            <div>
                <FlightFareBreakdown hideBreakdown={Boolean(proceedToPayment)} />

                <ActionButtonWrapper>
                    {
                        proceedToPayment ? (
                            <>
                                <div style={{ marginBottom: "10px" }}>
                                    <Checkbox onChange={handleChange} checked={accept}>
                                        I have read and agree to the <ConditionsRule inline /> within the <FareRule inline />
                                    </Checkbox>
                                </div>
                                <Button block size="large" type="primary" onClick={proceedToPayment} disabled={!accept}>
                                    Continue to payment
                                </Button>
                            </>

                            ) : (
                            <>
                                <div style={{ marginBottom: "10px" }}>
                                    <Checkbox onChange={handleChange} checked={accept}>
                                        I have read and agree to the <ConditionsRule inline /> within the <FareRule inline />
                                    </Checkbox>
                                </div>
                                <Button block size="large" type="primary"  disabled={!accept} htmlType="submit">
                                    Continue to payment
                                </Button>
                            </>
                        )
                    }

                </ActionButtonWrapper>
            </div>
        </Card>
    );
};

export default FlightPaymentBreakdown;
